import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class CellsTips extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-cells__tips": true
    }, className);

    return <div className={ cls } { ...others }>{ children }</div>;
  }
}
